module.exports = __webpack_public_path__ + "static/instagram-logo2-8e654e52f71a6219eb8e7137bd1b50bf.png";